module.exports = __webpack_public_path__ + "img/90501208id.50e2241f.png";